import { useState, useEffect } from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import DataPrivacyConsentModal from '../../components/DataPrivacyConsentModal';
import Container from '../../layouts/Container';
import {
  getConsentsByProject,
  createConsent,
  updateConsent,
  setActiveConsent,
  deleteConsent,
} from '../../services/project/dataPrivacyService';
import { Pencil, XOctagon, Check2Circle  } from 'react-bootstrap-icons';
import AnchorTag from '../../components/AnchorTag';
import { useProjects } from '../../context/ProjectContext';

export default function DataPrivacyConsentManager() {
  const { projectId } = useParams();
  const [consents, setConsents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingConsent, setEditingConsent] = useState(null);
  const { isProjectReadOnly } = useProjects();

  const loadConsents = async () => {
    const data = await getConsentsByProject(projectId);
    setConsents(data);
  };

  useEffect(() => {
    loadConsents();
  }, [projectId]);

  const handleSave = async form => {
    if (editingConsent) {
      await updateConsent(projectId, editingConsent.id, form);
      toast.success('Consent updated.');
    } else {
      await createConsent(projectId, form);
      toast.success('Consent created.');
    }
    setShowModal(false);
    setEditingConsent(null);
    loadConsents();
  };

  const handleSetActive = async id => {
    await setActiveConsent(projectId, id);
    loadConsents();
  };

  const handleDelete = async id => {
    if (window.confirm('Delete this consent form?')) {
      await deleteConsent(projectId, id);
      toast.success('Consent deleted.');
      loadConsents();
    }
  };

  return (
    <Container>
    <div className="d-flex align-items-center mb-3 gap-2">
      <h2>Data Privacy Consent Forms</h2>
      {!isProjectReadOnly && (<Button variant="primary" onClick={() => setShowModal(true)}>
        Add New
      </Button>)}
    </div>
    <div>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Preview</th>
            <th>Status</th>
            {!isProjectReadOnly && (<th>Actions</th>)}
          </tr>
        </thead>
        <tbody>
          {consents.map((consent, index) => (
            <tr key={consent.id}>
              <td>{index + 1}</td>
              <td>{consent.content.slice(0, 50)}...</td>
              <td>
                {consent.isActive ? (
                  <Badge bg="success">Active</Badge>
                ) : (
                  <Badge bg="secondary">Inactive</Badge>
                )}
              </td>
              {!isProjectReadOnly && (<td>
                {!consent.isActive && (
                  <AnchorTag onClick={() => handleSetActive(consent.id)} hoverText='Set Active'>
                    <Check2Circle />
                  </AnchorTag>
                )}
                <AnchorTag 
                    onClick={() => {
                      setEditingConsent(consent);
                      setShowModal(true);
                    }} hoverText='Edit'>
                  <Pencil />
                </AnchorTag>
                <AnchorTag onClick={() => handleDelete(consent.id)} hoverText='Delete'>
                  <XOctagon />
                </AnchorTag>
              </td>)}
            </tr>
          ))}
        </tbody>
      </Table>

      <DataPrivacyConsentModal
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setEditingConsent(null);
        }}
        onSave={handleSave}
        initialData={editingConsent}
      />
    </div>
  </Container>
  );
}
